import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { DataGrid } from "@material-ui/data-grid";
import Tooltip from "@mui/material/Tooltip";
import Badge from "react-bootstrap/Badge";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import Card from "react-bootstrap/Card";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

//Context import
import AuthContext from "../../../components/shared/Context";
import GeneralDetailsCard from "../../Patients/List/GeneralDetailsCard";
import ClinicalDetailsCard from "../../Patients/List/ClinicalDetailsCard";
import BleedingHistoryCard from "../../Patients/List/BleedingHistoryCard";
import VaccinationDetailsCard from "../../Patients/List/VaccinationDetailsCard";
import AddressDetailsCard from "../../Patients/List/AddressDetailsCard";
import ContactDetailsCard from "../../Patients/List/ContactDetailsCard";
import EconomicStatusCard from "../../Patients/List/EconomicStatusCard";
import SchedulingDetailsCard from "../../Patients/List/SchedulingDetailsCard";

const UpcomingListChild = () => {
  let navigate = useNavigate();
  const [{ errorLogApi, dateFormatter }] = useAtom(gbState);
  const { loggedInUserDetails, setPatientDiagnosis, setFieldLabelFromArray } =
    useContext(AuthContext);
  const childRef = useRef();
  const [data, setData] = useState([]);
  const [visits, setVisits] = useState();
  const [visitRow, setVisitRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vdate, setVdate] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [recType, setRecType] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [unfilteredData, setUnFilteredData] = useState(data);
  const [timeFilter, setTimeFilter] = useState("all");

  let user = jwt_decode(localStorage.getItem("token"));
  const getDataFromServer = () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const bodyParameters = {
      key: "value",
    };
    let urlLink = `${process.env.REACT_APP_API_URL}/appointment/tc/${user?.tc_id}`;
    axios
      .get(urlLink, config)
      .then((res) => {
        //const oldData = res.data.appointments;
        const upcoming = res.data.upcoming_appointments;
        const upcoming_updated = upcoming.map((data) => {
          return {
            id: data?._id,
            appointment_date: dateFormatter(data?.appointment_date),
            ap_date: data?.appointment_date,
            appointment_time: data?.appointment_time,
            appointment_type: data?.appointment_type,
            visit_type: data?.visit_type,
            appointment_status: data?.appointment_status,
            patient_name: data?.patient_id?.patient_name,
            patientId: data?.patient_id?.patientId,
            completed_visit_status: 0,
            ...data,
          };
        });
        setData(upcoming_updated);
        setUnFilteredData(upcoming_updated);
      })
      .catch((err) => {
        errorLogApi(err, "AppointmentListChild", urlLink);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const handleDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this patient ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(id),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (id) => {
    toast.error(
      "The Appointment Record cannot be Deleted from here. Kindly visit the Appointment Center."
    );
    return;
  };

  const badgeColor = {
    pending: "warning",
    completed: "success",
    cancelled: "danger",
    reschedule: "primary",
  };

  const viewRecord = (rec, rType) => {
    setCurrentRecord(rec);
    setRecType(rType);
    setOpenModal(true);
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      width: 100,
      sortable: false,
      hideable: false,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="editiConContainer">
            <Tooltip title="View Appointment">
              <a onClick={() => viewRecord(params.row, "AP")}>
                <i
                  className="mdi mdi-eye-circle-outline"
                  style={{ fontSize: "15px", color: "black" }}
                ></i>
              </a>
            </Tooltip>
            <Tooltip title="Delete Appointment">
              <div
                onClick={() => {
                  if (visits?.includes(params.row.ap_date)) {
                    toast.error("The Appointment cannot be Deleted");
                  } else {
                    handleDelete(params.row._id);
                  }
                }}
              >
                <i
                  className="mdi mdi-trash-can-outline"
                  style={{
                    fontSize: "15px",
                    color: "red",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Edit Appointment">
              <div
                onClick={() => {
                  if (visits?.includes(params.row.ap_date)) {
                    toast.error("The Appointment cannot be Edited");
                  } else {
                    navigate("/editappointment", {
                      state: {
                        appointment: params.row,
                        patient_data: params.row.patient_id,
                      },
                    });
                  }
                }}
              >
                <i
                  className="mdi mdi-square-edit-outline"
                  style={{
                    fontSize: "15px",
                    color: "grey",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
            </Tooltip>
            <Tooltip title="Create a Visit">
              <div
                onClick={() => {
                  setLoading(true);
                  setVdate(params.row.ap_date);
                  setVisitRow(params.row);
                  setPatientVisitStatus(
                    params.row.ap_date,
                    params.row.patient_id._id
                  );
                }}
              >
                <i
                  className="mdi mdi-plus-box"
                  style={{
                    fontSize: "15px",
                    color: "green",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "patient_name",
      headerName: "Patient Name",
      width: 180,
      renderCell: (params) => (
        <PatientInfo
          patientId={params.row.patientId}
          patient_name={params.row.patient_name}
          viewRecord={viewRecord}
          row={params.row}
        />
      ),
    },
    {
      field: "ap_date",
      headerName: "Date",
      width: 110,
      renderCell: (params) => dateFormatter(params.row.ap_date),
    },
    {
      field: "appointment_time",
      headerName: "Time",
      width: 90,
      sortable: false,
      hideable: false,
      align: "center",
    },
    {
      field: "appointment_type",
      headerName: "Appointment",
      width: 150,
      sortable: false,
      hideable: false,
      align: "center",
      renderCell: (params) => JSON.parse(params.row.appointment_type).label,
    },
    {
      field: "visit_type",
      headerName: "Purpose",
      width: 150,
      sortable: false,
      hideable: false,
      align: "center",
      renderCell: (params) =>
        params?.row?.visit_type
          ? JSON.parse(params?.row?.visit_type)?.label
          : "N/A",
    },
    {
      field: "appointment_status",
      headerName: "Ap. Status",
      width: 130,
      sortable: false,
      hideable: false,
      align: "center",
      renderCell: (params) => {
        return (
          <CheckVisitStatus
            visit_date={params.row.ap_date}
            appointment_status={params.row.appointment_status}
            patientRecordId={params.row.patient_id?._id}
          />
        );
      },
    },
  ];

  const setPatientVisitStatus = async (visit_date, patientRecordId) => {
    //console.log("SetVisist Status called");
    const visitDate = new Date(visit_date);
    const currentDate = new Date();

    const formattedDate = `${visitDate.toDateString().slice(0, 3)} ${visitDate
      .toDateString()
      .slice(4, 10)} ${visitDate.getFullYear()}`;

    // Remove the time portion from both dates for an accurate comparison
    visitDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (visitDate.getTime() !== currentDate.getTime()) {
      return toast.error(
        `Please re-visit on ${formattedDate} to create a visit.`
      );
    }

    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const bodyParameters = {
      key: "value",
    };
    let urlLink = `${process.env.REACT_APP_API_URL}/appointment/patient/visits/${patientRecordId}`;
    axios
      .get(urlLink, config)
      .then((res) => {
        //console.log(res.data);
        const visitData = res.data.visits;
        //console.log("Visits: ", visitData);
        const visitArray = [];
        visitData.map((date) => visitArray.push(date.date_of_visit));
        console.log("Visits: ", visitArray);
        setVisits(visitArray);
        setLoading(false);
      })
      .catch((err) => {
        errorLogApi(err, "AppointmentListChild", urlLink);
        setLoading(false);
      });

    return visits?.includes(visit_date) ? true : false;
  };

  useEffect(() => {
    //console.log("useEffect Working");
    if (!loading && vdate) {
      if (visits.includes(vdate)) {
        toast.error("The Visit already exists");
      } else {
        if (!visitRow?.appointment_status) {
          navigate(`/create-visit/`, {
            state: {
              ...visitRow?.patient_id,
              id: visitRow?.patient_id?._id,
              appointment_date: visitRow?.ap_date,
              visit_reason: visitRow?.appointment_type,
              visit_type: visitRow?.visit_type,
            },
          });
        } else if (
          visitRow?.appointment_status &&
          JSON.parse(visitRow?.appointment_status).label === "Pending"
        ) {
          navigate(`/create-visit/`, {
            state: {
              ...visitRow?.patient_id,
              id: visitRow?.patient_id?._id,
              appointment_date: visitRow?.ap_date,
            },
          });
        } else {
          toast.error("The Visit cannot be created");
        }
      }
    }
  }, [visits, loading]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value) {
      // If search is cleared, reset to filtered data based on current time filter
      const timeFiltered = applyTimeFilter(unfilteredData);
      setData(timeFiltered);
      return;
    }

    // Apply search filter on current data
    const searchFiltered = data.filter(
      (item) =>
        item.patient_name?.toLowerCase().includes(value.toLowerCase()) ||
        item.patientId?.toLowerCase().includes(value.toLowerCase()) ||
        item.contact?.email?.toLowerCase().includes(value.toLowerCase())
    );

    setData(searchFiltered);
  };

  const handleTimeFilterChange = (newTimeFilter) => {
    setTimeFilter(newTimeFilter);

    // First apply time filter
    let filtered = applyTimeFilter(unfilteredData, newTimeFilter);

    // Then apply search filter if exists
    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item.patient_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.patientId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.contact?.email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setData(filtered);
  };

  const applyTimeFilter = (dataToFilter, currentTimeFilter = timeFilter) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (currentTimeFilter) {
      case "today":
        return dataToFilter.filter((item) => {
          const appointmentDate = new Date(item.ap_date);
          appointmentDate.setHours(0, 0, 0, 0);
          return appointmentDate.getTime() === today.getTime();
        });
      case "future":
        return dataToFilter.filter((item) => {
          const appointmentDate = new Date(item.ap_date);
          appointmentDate.setHours(0, 0, 0, 0);
          return appointmentDate.getTime() > today.getTime();
        });
      default:
        return dataToFilter;
    }
  };

  const renderTimeFilters = () => (
    <div className="mb-3 d-flex align-items-center">
      <div className="me-3">Filter by time:</div>
      <Form.Check
        inline
        label="All"
        name="timeFilter"
        type="radio"
        checked={timeFilter === "all"}
        onChange={() => handleTimeFilterChange("all")}
      />
      <Form.Check
        inline
        label="Today"
        name="timeFilter"
        type="radio"
        checked={timeFilter === "today"}
        onChange={() => handleTimeFilterChange("today")}
      />
      <Form.Check
        inline
        label="Future"
        name="timeFilter"
        type="radio"
        checked={timeFilter === "future"}
        onChange={() => handleTimeFilterChange("future")}
      />
    </div>
  );

  // onChange={handleSearchChange}
  return (
    <div>
      <h1 className="allPatients">Upcoming Appointments</h1>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Search Patients</InputGroup.Text>
          <Form.Control
            placeholder="Name, iCareID, Email..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            onChange={handleSearchChange}
          />
        </InputGroup>
      </div>

      {renderTimeFilters()}

      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        displayTitle="Appointments"
        checkboxSelection
        style={{ height: "40vh" }}
      />
      {/* {JSON.stringify(data)} */}
      {/* Modal Popup */}
      <Modal show={openModal} size={recType === "AP" ? "md" : "lg"} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent
            currentRecord={currentRecord}
            recType={recType}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

const PatientInfo = ({ patientId, patient_name, viewRecord, row }) => {
  return (
    <>
      <span className="text-xs">
        <i
          className="mdi mdi-information"
          style={{ fontSize: "15px", color: "green", cursor: "pointer" }}
          onClick={() => viewRecord(row?.patient_id, "PT")}
        ></i>
        &nbsp;
        {patient_name}
        {/* <p className="text-[8px] text-gray-500 truncate text-light">
          {patientId}
        </p> */}
      </span>
    </>
  );
};

const CheckVisitStatus = ({
  visit_date,
  appointment_status,
  patientRecordId,
}) => {
  const [visits, setVisits] = useState();
  //Error Logging Service
  const [{ errorLogApi }] = useAtom(gbState);
  const badgeColor = {
    pending: "warning",
    completed: "success",
    cancelled: "danger",
    reschedule: "primary",
  };

  //console.log(visit_date);
  useEffect(() => {
    const getDataFromServer = () => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const bodyParameters = {
        key: "value",
      };
      let urlLink = `${process.env.REACT_APP_API_URL}/appointment/patient/visits/${patientRecordId}`;
      axios
        .get(urlLink, config)
        .then((res) => {
          //console.log(res.data);
          const visitData = res.data.visits;
          //console.log("Visits: ", visitData);
          const visitArray = [];
          visitData.map((date) => visitArray.push(date.date_of_visit));
          //console.log("Visits: ", visitArray);
          setVisits(visitArray);
        })
        .catch((err) => {
          errorLogApi(err, "AppointmentListChild", urlLink);
        });
    };
    getDataFromServer();
  }, []);
  //console.log("Visits from State: ", visits);
  return visits?.includes(visit_date) ? (
    <Badge bg={badgeColor[`completed`]}>
      &nbsp;&nbsp;COMPLETED&nbsp;&nbsp;
    </Badge>
  ) : appointment_status ? (
    <Badge
      bg={badgeColor[`${JSON.parse(appointment_status).label.toLowerCase()}`]}
    >
      {JSON.parse(appointment_status).label.toUpperCase()}
    </Badge>
  ) : (
    <Badge bg="warning">&nbsp;&nbsp;PENDING&nbsp;&nbsp;</Badge>
  );
};

const ModalContent = ({ currentRecord, recType, setFieldLabelFromArray }) => {
  const dateFormatter = (date) => {
    if (!date) return "";
    const formattedDate = new Date(date);
    if (!(formattedDate instanceof Date && !isNaN(formattedDate))) return "";
    const day = formattedDate.getDate().toString().padStart(2, "0");
    const month = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
    const year = formattedDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="container-fluid legend">
      {recType === "AP" && (
        <Card>
          <Card.Header>
            <i className="fas fa-align-justify" />
            <strong>Appointment Details</strong>
          </Card.Header>
          <Card.Body>
            <div key={currentRecord._id} className="row ">
              <div className="col-md-6 col-xs-6 divTableCell">Date</div>
              <div className="col-md-6 col-xs-6 divTableCell">
                {currentRecord.appointment_date &&
                  dateFormatter(currentRecord.appointment_date)}
              </div>
            </div>
            <div key={currentRecord.appointment_time} className="row ">
              <div className="col-md-6 col-xs-6 divTableCell">Time</div>
              <div className="col-md-6 col-xs-6 divTableCell">
                {currentRecord.appointment_time}
              </div>
            </div>
            <div key={currentRecord.appointment_type} className="row ">
              <div className="col-md-6 col-xs-6 divTableCell">
                Appointment Type
              </div>
              <div className="col-md-6 col-xs-6 divTableCell">
                {JSON.parse(currentRecord.appointment_type).label}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xs-12 divTableCell text-center h6 mt-2">
                Description
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xs-12 divTableCell">
                {currentRecord.appointment_notes}
              </div>
            </div>
          </Card.Body>
        </Card>
      )}
      {recType === "PT" && (
        <div className="container-fluid legend">
          <GeneralDetailsCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <ClinicalDetailsCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <BleedingHistoryCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <VaccinationDetailsCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <AddressDetailsCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <ContactDetailsCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <EconomicStatusCard
            currentRecord={currentRecord}
            setFieldLabelFromArray={setFieldLabelFromArray}
          />
          <SchedulingDetailsCard currentRecord={currentRecord} />
          {/* {JSON.stringify(currentRecord)} */}
        </div>
      )}
    </div>
  );
};

export default UpcomingListChild;
